import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../../../hooks/AuthContext";
import { i18n } from "../../../../localization/i18n";
import { 
  Container, 
  MainLayout,
  CertificateContainer,
  CertificateWrapper, 
  ParticipantName, 
  CourseName, 
  DateText,
  DurationText,
  ActionsPanel,
  DownloadButton,
  SecondaryButton,
  BackgroundImage,
  OverlayContent
} from "./styles";
import { FiDownload, FiImage } from "react-icons/fi";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import CertificateBackground from "../../../../assets/certificate-bg.png";

export default function Certificate() {
  const { setNavigationAction, user } = useAuth();
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingImage, setIsDownloadingImage] = useState(false);
  const certificateRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setNavigationAction({
      hasButton: false,
      description: i18n.t("sidebar.certificate") || "Certificado",
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const today = new Date().toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "long",
    year: "numeric"
  });

  const handleDownloadPDF = async () => {
    if (!certificateRef.current) return;
    
    try {
      setIsDownloading(true);
      
      const canvas = await html2canvas(certificateRef.current, {
        scale: 2, // High resolution
        useCORS: true, // Allows loading external images if any
        logging: false,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      // A4 Landscape dimensions: 297 x 210 mm
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`Certificado_Fix_it_${user?.person?.name?.replace(/\s+/g, '_') || 'Aluno'}.pdf`);

    } catch (error) {
      console.error("Erro ao gerar o PDF do certificado:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleDownloadImage = async () => {
    if (!certificateRef.current) return;
    
    try {
      setIsDownloadingImage(true);
      
      const canvas = await html2canvas(certificateRef.current, {
        scale: 3, // Very high resolution for Instagram/WhatsApp
        useCORS: true,
        logging: false,
      });

      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      const link = document.createElement('a');
      link.href = imgData;
      link.download = `Certificado_Fix_it_${user?.person?.name?.replace(/\s+/g, '_') || 'Aluno'}.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error("Erro ao gerar a Imagem do certificado:", error);
    } finally {
      setIsDownloadingImage(false);
    }
  };

  return (
    <Container>
      <MainLayout>
        <CertificateContainer>
          <CertificateWrapper ref={certificateRef}>
            <BackgroundImage src={CertificateBackground} alt="Certificado Background" />
            
            <OverlayContent>
              <ParticipantName>{user?.person?.name || "Aluno Fix it"}</ParticipantName>
              
              <CourseName>Curso Órteses Fix it 3D</CourseName>
              
              <DateText>{today}</DateText>
              <DurationText>6 horas (seis horas)</DurationText>
            </OverlayContent>
          </CertificateWrapper>
        </CertificateContainer>

        <ActionsPanel>
          <SecondaryButton onClick={handleDownloadImage} disabled={isDownloadingImage}>
            <FiImage />
            {isDownloadingImage ? "Gerando..." : "Baixar .jpg"}
          </SecondaryButton>

          <DownloadButton onClick={handleDownloadPDF} disabled={isDownloading}>
            <FiDownload />
            {isDownloading ? "Gerando..." : "Baixar .pdf"}
          </DownloadButton>
        </ActionsPanel>
      </MainLayout>
    </Container>
  );
}
